import { useQuery } from "@tanstack/react-query";
import { Check, Minus, Plus } from "lucide-react";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";

import { ProductImage } from "../components/ProductCard";
import { ErrorPanel, Loading } from "../components/States";
import { storeQueries } from "../lib/api";
import { useCart } from "../lib/cart";
import { money } from "../lib/types";

export function ProductPage() {
  const { slug = "" } = useParams();
  const { data: product, isLoading, error } = useQuery({ queryKey: ["product", slug], queryFn: () => storeQueries.product(slug) });
  const { add } = useCart();
  const [size, setSize] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [added, setAdded] = useState(false);
  const [activeImage, setActiveImage] = useState(0);
  if (isLoading) return <Loading />;
  if (error || !product) return <ErrorPanel message="That piece could not be found." />;
  const image = product.images[activeImage];
  function addItem() {
    if (product!.sizes.length && !size) return;
    add(product!, size || null, quantity);
    setAdded(true);
  }
  return (
    <section className="product-page section">
      <div className="breadcrumbs"><Link to="/shop">Shop</Link><span>/</span><Link to={`/shop/${product.category.slug}`}>{product.category.name}</Link><span>/</span><span>{product.name}</span></div>
      <div className="product-detail-grid">
        <div className="product-gallery">
          <div className="gallery-main">{image ? <img src={image.url_large} srcSet={`${image.url_small} 560w, ${image.url_medium} 1120w, ${image.url_large} 2000w`} alt={image.alt_text || product.name} /> : <ProductImage product={product} size="detail" />}</div>
          {product.images.length > 1 && <div className="gallery-thumbs">{product.images.map((item, index) => <button className={index === activeImage ? "active" : ""} onClick={() => setActiveImage(index)} key={item.id}><img src={item.url_small} alt={`View ${index + 1} of ${product.name}`} /></button>)}</div>}
        </div>
        <div className="product-detail-copy">
          <p className="eyebrow">{product.category.name} · Handmade to order</p><h1>{product.name}</h1><p className="price large">{money(product.price_cents)}</p><p className="product-description">{product.description}</p>
          {product.sizes.length > 0 && <fieldset className="size-picker"><legend>Choose your size</legend><div>{product.sizes.map((item) => <button type="button" className={size === item.label ? "selected" : ""} onClick={() => setSize(item.label)} key={item.id}>{item.label}</button>)}</div></fieldset>}
          <div className="purchase-row"><div className="quantity-picker"><button onClick={() => setQuantity(Math.max(1, quantity - 1))} aria-label="Decrease quantity"><Minus /></button><span>{quantity}</span><button onClick={() => setQuantity(Math.min(5, quantity + 1))} aria-label="Increase quantity"><Plus /></button></div><button className="button primary grow" onClick={addItem} disabled={product.status !== "published" || (product.sizes.length > 0 && !size)}>{added ? <><Check /> Added to bag</> : product.status === "published" ? "Add to bag" : "Unavailable"}</button></div>
          <div className="product-facts"><div><span>Made to order</span><strong>{product.turnaround}</strong></div><div><span>Materials & care</span><p>{product.materials_care || "Care details will be included with your piece."}</p></div></div>
        </div>
      </div>
    </section>
  );
}
